import React from 'react';
import { withTheme } from 'styled-components';
import { meanBy } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import helpers from 'helpers';

const SparkLine = (props) => {
    const seriesData = helpers.backfill(
        props.data.map(r => ({ x: r.date_in_ms, y: r[props.y] })),
        props.backfillBuckets
    );
    const plotLineMidpoint = meanBy(seriesData, 'x');
    const categories = props.data.categories;

    return (
        <AbstractChart exportName={props.exportName} config={{
            chart: {
                margin: [0, 0, 0, 0],
                backgroundColor: 'transparent',
                height: '35px'
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            credits: {
                enabled: false
            },
            xAxis: {
                labels: {
                    enabled: true
                },
                title: {
                    text: 'null'
                },
                startOnTick: false,
                endOnTick: false,
                tickPositions: [],
                categories,
                plotLines: [{
                    color: props.theme.colors.darkgray,
                    width: 1,
                    value: plotLineMidpoint,
                    zIndex: 5
                }]
            },
            yAxis: {
                endOnTick: false,
                startOnTick: false,
                labels: {
                    enabled: false
                },
                title: {
                    text: null
                },
                tickPositions: [0]
            },
            legend: {
                enabled: false,
                itemStyle: {
                    color: props.theme.colors.darkgray
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                series: {
                    animation: {
                        duration: props.animateDuration
                    },
                    enableMouseTracking: false,
                    lineWidth: 1,
                    shadow: false,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    marker: {
                        enabled: false
                    }
                }
            },
            series: [{
                type: 'area',
                color: props.fill || props.theme.charts.sparkline,
                fillColor: props.fill || props.theme.charts.sparkline,
                data: seriesData
            }]
        }} />
    );
};

export default withTheme(SparkLine);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/SparkLine.js